"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Link_1 = require("./../Link");
var Legal = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    return (React.createElement("div", { "data-testid": testId, className: (options === null || options === void 0 ? void 0 : options.onDark) ? "color-ui-white" : "color-ui-black" },
        React.createElement("div", { className: (options.className || "") + " type-legal" },
            data.legalText,
            (options === null || options === void 0 ? void 0 : options.linkProps) && (React.createElement("span", null,
                React.createElement(Link_1.default, __assign({}, options === null || options === void 0 ? void 0 : options.linkProps), options.legalLinkText))))));
};
exports.default = Legal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Legal/Legal.js
// module id = 1778
// module chunks = 8